module.exports = __webpack_public_path__ + "img/female-infant-hand.e5a3dcfb.svg";